export default "__VITE_ASSET__DUS750dU__"